import { Component, Inject, Input } from '@angular/core';
import { PickupViewModel } from './reservation.page';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';


@Component({
    selector: 'app-pickup-item[item]',
    styles: [`
    :host {
      display: block;
    }
    .email-container {
      word-wrap: break-word;
    }
    .icon-container {
      height: 50px;
      width: 50px;
      min-width: 50px;
    }
    .product-icon-s {
      height: 30px;
      width: 30px;
    }
    .product-icon-m {
      height: 40px;
      width: 40px;
    }
    .product-icon-l {
      height: 50px;
      width: 50px;
    }

    .icon-container .product-icon-s:nth-of-type(2) {
      top: 10px;
      left: 10px;
    }
    .icon-container .product-icon-s:nth-of-type(3) {
      top: 20px;
      left: 20px;
    }
    .icon-container .product-icon-m:nth-of-type(2) {
      top: 10px;
      left: 10px;
    }

    .date-time-card {
      max-width: 80px;
    }
  `],
    template: `
    <!-- Horizontal alignment -->
    <div class="d-none d-md-flex flex-row pt-3 pb-3 align-items-center">
      <div class="flex-column col-1">
        <div class="d-flex flex-row align-items-center" *ngIf="!item.pickedAt">
          <div class="me-2 px-2 border-medium border rounded bg-secondary text-white">
            <time [attr.datetime]="item.pickupAt" class="d-flex w-100 flex-column align-items-center">
              <span class="material-icons fs-2">access_time</span>
              <span class="fw-bold text-center">
                {{(item.isReservation ? item.expiresAt : item.pickupAt) | diffFromNow}}
              </span>
            </time>
          </div>
        </div>
        <div class="d-flex flex-column" *ngIf="item.pickedAt">
          <span class="fs-6 text-info fw-bold text-center ms-1 code">{{item.code}}</span>
        </div>
      </div>
      <div class="flex-column ps-3 col-2">
        <div>
          <span class="fs-6 text-info fw-bold text-end ms-1">
            {{item.isReservation ? 'Reservierung' : 'Click & Collect'}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column col-4">
        <div class="d-flex flex-row align-items-center">
          <div class="d-flex flex-column align-items-center">
            <div class="position-relative icon-container">
              <div
                class="d-block bg-light square-image shadow-sm border position-absolute"
                *ngFor="let pi of item.items.slice(0, 2)"
                [style.background-image]="pi.product.imageUrl && 'url(' + pi.product.imageUrl + ')'"
                [class]="productIconClass"
              >
              </div>
            </div>
          </div>
          <div class="d-flex flex-column ps-2">
            <span class="ps-2">
              <span
                *ngIf="item.items.length === 1"
                [class]="item.items[0].product.title ? '' : 'text-danger'"
              >
                {{item.items[0].product.title
                  ? item.items[0].product.title
                  : 'Produkt-ID: ' + item.items[0].product.id + ' Dieses Produkt wurde gelöscht.'
                }}
              </span>
              <span *ngIf="item.items.length === 1" class="d-block">
                {{item.items[0].options.join(', ')}}
              </span>
              <span *ngIf="item.items.length === 0">
                {{item.items.length}} Artikel
              </span>
            </span>
          </div>
          <div *ngIf="item.items.length > 1" class="d-flex flex-row align-items-center mx-2">
            <span class="text-info ps2" *ngIf="layout === 'desktop'">Alle Produkte anzeigen</span>
            <button class="btn info-button text-info mx-2" (click)="toggleItemExpand(item)">
              <span class="material-icons" *ngIf="!item.expanded">keyboard_arrow_down</span>
              <span class="material-icons" *ngIf="item.expanded">keyboard_arrow_up</span>
            </button>
            <span class="material-icons icon-size text-danger" *ngIf="nullItemsSize">
              error_outline
            </span>
          </div>
        </div>
      </div>
      <div class="flex-column ps-3 col-2 text-break">
        <span *ngIf="item.items.length === 1">{{item.items[0].product.code}}</span>  
      </div>
      <div class="flex-column ps-3 col-2 text-fade-out">{{item.name || item.email}}</div>
      <div class="flex-column d-flex align-items-end ps-3 col-1 pe-3">
        <span class="flex-row fs-6 text-info fw-bold text-end">{{calculateOverallPrice | currency}}</span>
      </div>
    </div>
    <div class="d-flex flex-column" *ngIf="item.expanded">
      <div class="d-none d-md-flex flex-row pt-3 pb-3 align-items-center" *ngFor="let pi of item.items">
        <div class="d-flex col-3"></div>
        <div class="d-flex col-6 align-items-center">
          <div
            class="product-image-placeholder border-medium border bg-white w-48px h-48px me-2 position-relative flex-shrink-0 square-image"
            [style.background-image]="pi.product.imageUrl && 'url(' + pi.product.imageUrl + ')'">
            <div class="position-absolute start-100 translate-middle badge rounded-pill bg-info">
              {{pi.product.quantity}}
            </div>
          </div>
          <div class="flex-grow-1 ps-2">
            <span *ngIf="pi.product.title">
              {{pi.product.title}}
              <br *ngIf="!!pi.product.code" />
              {{pi.product.code}}
            </span>
            <span class="text-danger" *ngIf="!pi.product.title">
              Produkt-ID: {{pi.product.id}} Dieses Produkt wurde gelöscht.
            </span>
          </div>
        </div>
        <div class="flex-column d-flex align-items-end ps-3 col-3 pe-3">
          <span class="flex-row fs-6 text-info fw-bold text-end">{{pi.product.price | currency}}</span>
        </div>
      </div>
    </div>

    <!-- Vertical alignment -->
    <div class="d-flex d-md-none flex-column">
      <div class="d-flex d-md-none flex-row pt-3 pb-3 align-items-center justify-content-between">
        <div class="d-flex align-items-center overflow-hidden">
          <div class="me-2 px-2 border-medium border rounded bg-secondary text-white" *ngIf="!item.pickedAt">
            <time [attr.datetime]="item.pickupAt" class="d-flex w-100 flex-column align-items-center">
              <span class="material-icons fs-2">access_time</span>
              <span class="fw-bold text-center date-time-card">
                {{(item.isReservation ? item.expiresAt : item.pickupAt) | diffFromNow}}
              </span>
            </time>
          </div>
          <div class="d-flex flex-column" *ngIf="item.pickedAt">
            <span class="fs-6 text-info fw-bold text-end ms-1 code">{{item.code}}</span>
          </div>

          <div class="overflow-hidden d-flex flex-column">
            <span class="ps2 text-info fw-bold ms-1">
              {{item.isReservation ? 'Reservierung' : 'Click & Collect'}}
            </span>
          </div>
        </div>
        <div class="ps-2">
          <span class="fs-6 text-info fw-bold text-end">{{calculateOverallPrice | currency}}</span>
        </div>
      </div>
      <div class="d-flex d-md-none flex-row pt-3 pb-3 align-items-center justify-content-between">
        <div class="d-flex align-items-center overflow-hidden w-100">

          <div class="position-relative icon-container align-self-start">
            <div class="d-block bg-light square-image shadow-sm border position-absolute" *ngFor="let pi of item.items.slice(0, 2)"
                 [style.background-image]="pi.product.imageUrl && 'url(' + pi.product.imageUrl + ')'" [class]="productIconClass">
            </div>
          </div>

          <div
            class="overflow-hidden d-flex flex-column w-100"
            [ngClass]="{'text-fade-out': !(item.expanded && item.items.length === 1)}"
          >
            <span class="ps-2">
              <span
                *ngIf="item.items.length === 1"
                [class]="item.items[0].product.title ? '' : 'text-danger'"
              >
                {{item.items[0].product.title
                  ? item.items[0].product.title
                  : 'Produkt-ID: ' + item.items[0].product.id + ' Dieses Produkt wurde gelöscht.'
                }}
              </span>
              <span *ngIf="item.items.length === 1" class="d-block">
                {{item.items[0].options.join(', ')}}
              </span>
              <span *ngIf="item.items.length !== 1">
                {{item.items.length}} Artikel
              </span>
            </span>
            <div class="ps-2" *ngIf="item.expanded && item.items.length === 1">
              {{item.items[0].product.code}}
            </div>
            <span class="ps-2 email-container">{{item.name || item.email}}</span>
          </div>
        </div>
        <div class="ps-2 align-self-start">
          <div class="d-flex flex-row align-items-center mx-2">
            <button class="btn info-button text-info" (click)="toggleItemExpand(item)">
              <span class="material-icons" *ngIf="!item.expanded">keyboard_arrow_down</span>
              <span class="material-icons" *ngIf="item.expanded">keyboard_arrow_up</span>
            </button>
            <span class="material-icons icon-size text-danger" *ngIf="nullItemsSize">
              error_outline
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-none flex-column" *ngIf="item.expanded && item.items.length === 1">
    </div>
    <div
      class="d-flex d-md-none flex-column"
      *ngIf="item.expanded && item.items.length > 1"
    >
      <div class="d-flex align-items-center flex-row justify-content-between" *ngFor="let pi of item.items">
        <div class="d-flex align-items-center mb-1" [class]="{'pe-5': !pi.product.title}">
          <div
            class="product-image-placeholder border-medium border bg-white w-48px h-48px me-2 position-relative flex-shrink-0 square-image"
            [style.background-image]="pi.product.imageUrl && 'url(' + pi.product.imageUrl + ')'">
            <div class="position-absolute start-100 translate-middle badge rounded-pill bg-info">
              {{pi.product.quantity}}
            </div>
          </div>
          <div class="ps-2" [class]="{'text-danger': !pi.product.title}">
            {{pi.product.title
              ? pi.product.title
              : 'Produkt-ID: ' + pi.product.id + ' Dieses Produkt wurde gelöscht.'
            }}
            <br *ngIf="pi.product.code" />
            {{pi.product.code}}
          </div>
        </div>
        <div class="ps-2">
          <span class="fs-6 text-info fw-bold text-end">{{ pi.product.price | currency }}</span>
        </div>
      </div>
    </div>
  `,
    standalone: false
})
export class PickupItemComponent {
  @Input() item!: PickupViewModel;

  constructor(@Inject(SCREEN_LAYOUT) public layout: ScreenLayout,
  ) {}

  /**
   * Returns the count of items that have been deleted (items without a title)
   * @returns {number} Number of items with missing titles
   */
  get nullItemsSize() {
    return this.item.items.filter(item => !item.product.title).length;
  }

  /**
   * Calculates the overall price of the pickup item
   * @returns {number} Total price of all items
   */
  get calculateOverallPrice() {
    return this.item.items.reduce((acc, { product: { price } }) => acc + +(price || 0), 0);
  }

  /**
   * Returns the class for the product icon based on the number of items
   * @returns {string} Class for the product icon
   */
  get productIconClass() {
    switch (this.item.items.length) {
      case 1:
        return 'product-icon-l';
      case 2:
        return 'product-icon-m';
      default:
        return 'product-icon-s';
    }
  }

  /**
   * Toggles the expanded state of the pickup item
   * @param {PickupViewModel} pickupItem - The pickup item to toggle
   */
  toggleItemExpand(pickupItem: PickupViewModel) {
    pickupItem.expanded = !pickupItem.expanded;
  }
}
